import Vue from 'vue'
import slug from 'slug'
slug.defaults.mode = 'rfc3986'

Array.from(document.querySelectorAll('.form-review-laws')).forEach(el => {
  new Vue({
    el,
    data() {
      return {
        zip: '',
        state: false,
        county: false,
        city: false,
        loading: false,
        failed: false,
      }
    },
    mounted() {
      // google.load('maps', '3',{ other_params:'libraries=geometry' }) // no longer needed we load dynamically
    },
    methods: {
      submit() {
        if(this.zip.length < 5) return this.failed = true
        this.loading = true
        this.failed = false
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode( {
          address: this.zip,
          componentRestrictions: {
            country: 'US'
          }
        }, (results, status) => {
          console.log(results)
          if(status == 'OK') {
            let address = results[0].address_components
            address.forEach(component => {
              console.log(component)
              if(component.types.indexOf('administrative_area_level_2') > -1) this.county = encodeURI(component.long_name)
              if(component.types.indexOf('administrative_area_level_1') > -1) this.state = slug(component.long_name)
            })
            this.loading = false
            if(this.state) {
              window.dataLayer.push({
                'event': 'eventTracking',
                'category': 'ReviewLaws',
                'action': 'ZipCode',
                'label': 'ZipCode',
                'value': this.zip,
              })
              return window.location.href = `/state-laws/${this.state}?county=${this.county}&zip=${this.zip}`
            }
          } else {
            this.loading = false
            this.failed = true
          }
        })
      }
    },
  })
})
